import { render, staticRenderFns } from "./VehicleOverviewDashboardView.vue?vue&type=template&id=384f9433&scoped=true&"
import script from "./VehicleOverviewDashboardView.vue?vue&type=script&lang=js&"
export * from "./VehicleOverviewDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./VehicleOverviewDashboardView.vue?vue&type=style&index=0&id=384f9433&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384f9433",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VRow})
